module.exports = __webpack_public_path__ + "images/An Ethnography of Decentralised Information Infrastructure.pdf?v=cb01f447f4f19d78f0f8d2d1e6426f15";